import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

export interface OverlayContext {
  display: boolean;
  componentCall?: () => void;
}

@Injectable({
  providedIn: "root",
})
export class OverlayService {
  private context = new BehaviorSubject<OverlayContext>({ display: false });
  public overlayInProgress = false;

  context$ = this.context.asObservable();

  constructor() {}

  show(componentCall?: () => void) {
    this.context.next({ display: true, componentCall: componentCall });
    this.overlayInProgress = true;
  }

  hide() {
    this.context.next({ display: false });
    this.overlayInProgress = false;
  }
}
